import * as lang from "./Language";
import { isInt, isNotInt } from "./Util";

const valueType = {
  hint: "Hint",
  value: "Value",
};

const slotResolutionTypes = {
  onlyHintRequired: "Only hint is required",
  onlyValueRequired: "Only value is required",
  bothAreRequired: "Both hint and value are required",
  atLeastOneIsRequired: "At least one is required",
};

export const symbolCompanyName = {
  key: "companyName",
  type: valueType.hint,
  variations: lang.companySynonyms(),
  defaultValue: "company",
};

export const symbolChar1 = {
  key: "char1",
  type: valueType.value,
  variations: [],

  defaultValue: "d",
};

export const symbolChar2 = {
  key: "char2",
  type: valueType.value,
  variations: [],

  defaultValue: "p",
};

export const symbolLetter = {
  key: "letter",
  type: valueType.hint,
  variations: ["letter", "letters", "character", "characters"],
  defaultValue: "letter",
};

export const symbolLowerCase = {
  key: "lowercase",
  type: valueType.value,
  variations: ["lowercase", "small", "lower"],
  defaultValue: "lowercase",
};

export const symbolChatbox = {
  key: "chatbox",
  type: valueType.value,
  variations: lang.chatSynonyms(),
  defaultValue: "chatbox",
};

export const symbolBubbles = {
  key: "bubbles",
  type: valueType.value,
  variations: lang.bubbleSynonyms(),
  defaultValue: "bubbles",
};
export const symbolSmoothen = {
  key: "smoothen",
  type: valueType.value,
  variations: [
    "smoothen",
    "round",
    "soften",
    "smooth",
    "curves",
    "curvy",
    "rounded",
    "soft",
  ],
  defaultValue: "smoothen",
};
export const symbolLines = {
  key: "lines",
  type: valueType.value,
  variations: [
    "lines",
    "borders",
    "line",
    "edges",
    "edge",
    "corner",
    "corners",
  ],
  defaultValue: "lines",
};

export const symbolLogo = {
  key: "logo",
  type: valueType.value,
  variations: [
    "finish",
    "complete",
    "done",
    "end",
    "final",
    "stop",
    "terminate",
    "wrap",
    "last",
    "close",
    "cease",
    "wind up",
    "sketch",
    "render",
    "logo",
    "finalise",
    "finalize",
  ],
  defaultValue: "logo",
};

export const secondOption = {
  key: "second",
  type: valueType.value,
  variations: lang.secondOptionKeywords(),
  defaultValue: "second",
};
const replacement = { replace: 1, addNew: 2 };
export const patternMatchType = { noMatch: 0, keyword: 1, regex: 2 };
/// ----- Slots
export const slotCharSelection = {
  level: 1,
  name: "Brand / Character Selection",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [],
  defaultValues: ["d", "p"],
  replace: replacement.replace,
  patterns: {
    wordAndWord: (input) => {
      let pattern = /(\w+|.) and (\w+|.)/;
      const matches = input.match(pattern);
      if (matches && matches.length >= 2) {
        return {
          one: matches[1],
          two: matches[2],
          success: true,
          matchType: patternMatchType.regex,
          matches,
        };
      }
      return { one: null, two: null, success: false };
    },
    brandNameIs: (input) => {
      let pattern =
        /(?:my|our|the)?( +)?(?:business|company|brand|shop|trade)( +)(?:name|title|label)?( +)?(?:is)( +)(.*)/i;
      const matches2 = input.match(pattern);
      // Brand name = matches2[5]
      if (matches2) {
        let brandName = matches2[5];
        if (brandName.endsWith(",")) {
          brandName = brandName.substr(0, brandName.length - 1);
        }
        if (brandName.toLowerCase().indexOf("is ") > 0) {
          brandName = brandName.substr(brandName.indexOf("is ") + 3);
        }
        return {
          one: brandName.trim(),
          two: "",
          success: true,
          matchType: patternMatchType.regex,
          matches: matches2,
        };
      }
      return {
        one: null,
        two: null,
        success: false,
        matchType: patternMatchType.noMatch,
      };
    },
  },
};

export const slotStyle = {
  level: 1.5,
  name: "slotStyle",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [],
  defaultValues: ["slotSecondOpt"],
  replace: replacement.addNew,
  patterns: {
    setAttribToValue: (input) => {
      const pattern =
        /(?!.*\b(low|lower|smaller|small|bubble|bubbles|balloon|balloons|chat|chatbox)\b)(?:change|make|set)(?: +)?(?:the)?(?: +)(.*)(?:to)?(?: +)(.*)/i;
      const matches = input.match(pattern);
      if (matches) {
        if (matches.length > 2) {
          let attrib = matches[2].trim();
          if (attrib.endsWith(" to")) {
            attrib = attrib.substring(0, attrib.length - 3);
          }
          return {
            one: attrib,
            two: matches[3].trim(),
            success: true,
            matchType: patternMatchType.regex,
            matches,
          };
        }
      }
      return {
        one: null,
        two: null,
        success: false,
        matchType: patternMatchType.noMatch,
      };
    },
  },
};
//    /(?:give|make|create|generate)?(?: +)?(?:me|us)(?: +)(\d+|few)?(?: +)?(?:more|further|design|logo|sketch)?(?: +)?(?:ideas|idea)?/

export const slotIdeas = {
  level: 7,
  name: "slotIdeas",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [],
  defaultValues: [],
  replace: replacement.replace,
  patterns: {
    giveMeXNumberOfIdeas: (input) => {
      const pattern =
        /(?:give|create|generate)?(?: +)?(?:me|us|a)?(?: +)(\d+|few|a few|some|more)(?: +)?(?:more|further|design|logo|sketch|logos|some|sketches)?(?: +)?(?:ideas|idea|designs)?(for me|for us)?/i;
      const matches = input.match(pattern);
      if (matches) {
        if (matches.length > 1) {
          let digit = 30;
          const theValue = matches[1].trim();
          if (isInt(theValue)) {
            digit = parseInt(theValue);
          }
          return {
            one: digit,
            two: null,
            success: true,
            matchType: patternMatchType.regex,
            matches,
          };
        }
      }
      return {
        one: null,
        two: null,
        success: false,
        matchType: patternMatchType.noMatch,
      };
    },
  },
};

export const slotLowerCase = {
  level: 2,
  name: "Small letters",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [symbolLetter, symbolLowerCase],
  defaultValues: ["lowercase"],
  replace: replacement.replace,
  Regex: [],
  patterns: {},
};

export const slotChatbox = {
  level: 3,
  name: "Chatbox",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [symbolChatbox],
  defaultValues: ["lowercase"],
  replace: replacement.replace,
  Regex: [],
  patterns: {},
};

export const slotBubbles = {
  level: 4,
  name: "Bubbles",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [symbolBubbles],
  defaultValues: ["bubbles"],
  replace: replacement.replace,
  Regex: [],
  patterns: {},
};

export const slotSmoothen = {
  level: 5,
  name: "Smoothen",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [symbolSmoothen, symbolLines],
  defaultValues: ["smoothen"],
  replace: replacement.replace,
  Regex: [],
  patterns: {},
};

export const slotLogo = {
  level: 6,
  name: "Logo",
  resolution: slotResolutionTypes.atLeastOneIsRequired,
  keys: [symbolLogo],
  defaultValues: ["logo"],
  replace: replacement.replace,
  Regex: [],
  patterns: {},
};

export const slots = [
  slotCharSelection,
  slotStyle,
  slotLowerCase,
  slotChatbox,
  slotBubbles,
  slotSmoothen,
  slotLogo,
  slotIdeas,
];

export const autofill = [
  {
    value: "draw me d and p",
  },
  {
    value: "make the letters lowercase",
  },
  {
    value: "turn the d and p into chatbox",
  },
  {
    value: "make the chat more like bubbles",
  },
  {
    value: "Smoothen lines",
  },
  {
    value: "turn the sketch into a beautiful logo",
  },
];
